import flowbiteTheme from '@wolfejs/ui/styles/themes/flowbite';
import ninjaTheme from '@wolfejs/ui/styles/themes/ninja';
import tailWindTheme from '@wolfejs/ui/styles/themes/tailwind';
import type { ThemeConfig } from '@wolfejs/ui/types/theme';

export const themeConfigs: ThemeConfig[] = [tailWindTheme, flowbiteTheme, ninjaTheme];
